
import Vue from 'vue'
import { ContactService } from '../services/ContactService'
import ModalComponent from './ModalComponent.vue'

function getDefaultData() {
  return {
    datenschutz: false,
    salutation: null,
    firstName: '',
    lastName: '',
    street: '',
    plz: '',
    city: '',
    country: '',
    email: '',
    phoneNumber: '',
    notes: '',
    state: 'entry',
    invalidFields: [] as string[]
  }
}

export default Vue.extend({
  name: 'ContactComponent',
  components: {
    ModalComponent
  },
  data: getDefaultData,
  computed: {
    currentHeading(): string {
      return (this.state === 'finished') ? this.$t('request.successMessage').toString() : this.$t('request.heading').toString()
    },
    showFeedback(): boolean {
      return this.state === 're_entry'
    },
    firstNameState(): boolean | null {
      if (!this.showFeedback) {
        return null
      }
      return this.firstName.length > 0 ? true : false
    },
    lastNameState(): boolean | null {
      if (!this.showFeedback) {
        return null
      }
      return this.lastName.length > 0 ? true : false
    },
    streetState(): boolean | null {
      if (!this.showFeedback) {
        return null
      }
      return this.street.length > 0 ? true : false
    },
    cityState(): boolean | null {
      if (!this.showFeedback) {
        return null
      }
      return this.city.length > 0 ? true : false
    },
    plzState(): boolean | null {
      if (!this.showFeedback) {
        return null
      }
      return this.plz.length > 0 ? true : false
    },
    phoneState(): boolean | null {
      if (!this.showFeedback) {
        return null
      }
      return this.phoneNumber.length > 0 ? true : false
    },
    emailState(): boolean | null {
      if (!this.showFeedback) {
        return null
      }
      return this.email.length > 0 ? true : false
    },
    countryState(): boolean | null {
      if (!this.showFeedback) {
        return null
      }
      return this.country.length > 0 ? true : false
    },
    price() {
      return this.$store.getters.price
    },
    colors() {
      return this.$store.getters.getColors
    }
  },
  methods: {
    async ok(e: Event) {
      e.preventDefault()
      this.state = 're_entry'
      if (this.checkInputs()) {
        this.state = 'sending'
        await ContactService.sendContactInformation({
          customerData: {
            salutation: this.salutation,
            firstName: this.firstName,
            lastName: this.lastName,
            street: this.street,
            plz: this.plz,
            city: this.city,
            country: this.country,
            email: this.email,
            phoneNumber: this.phoneNumber,
            notes: this.notes,
          },
          configuration: {
            price: this.price,
            colors: this.colors
          }
        })
        this.state = 'finished'
      }
    },
    maybeResetModal(): void {
      // only reset when user has submitted form
      if (this.state === 'finished') {
        Object.assign(this.$data, getDefaultData())
      }
    },
    openModal() {
      (this.$refs.modalComponent as any).openpopup()
    },
    checkInputs(): boolean {
      this.invalidFields = []
      if (!this.firstNameState) {
        this.invalidFields.push('Vorname')
      }
      if (!this.lastNameState) {
        this.invalidFields.push('Nachname')
      }
      if (!this.streetState) {
        this.invalidFields.push('Straße')
      }
      if (!this.cityState) {
        this.invalidFields.push('Stadt')
      }
      if (!this.plzState) {
        this.invalidFields.push('PLZ')
      }
      if (!this.phoneState) {
        this.invalidFields.push('Telefonnummer')
      }
      if (!this.emailState) {
        this.invalidFields.push('Email')
      }
      if (!this.countryState) {
        this.invalidFields.push('Land')
      }
      if (!this.datenschutz) {
        this.invalidFields.push('Datenschutz')
      }
      return this.invalidFields.length === 0
    }
  }
})
